import script from "./NewsCreateView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsCreateView.vue?vue&type=script&setup=true&lang=js"

import "./NewsCreateView.vue?vue&type=style&index=0&id=0656f2ae&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0656f2ae"]])

export default __exports__